module.exports = __webpack_public_path__ + "img/wine_icon.f8059bd.png";